import { api } from "@engineernow/convex-client";
import { PriceUpdateType } from "../pages/types";
import { convexAction, convexMutation, convexQuery, downloadUrl } from "../convex/call";

// Продукты и цены, статистика и выгрузка платежей. Список платежей — usePaginatedQuery
// (api.admin.commerce.payments) на странице.
export const getPrices = async () => {
    return convexQuery(api.admin.commerce.products, {});
}

export const updatePrice = async (items: PriceUpdateType[]) => {
    return convexMutation(api.admin.commerce.updatePrices, { items: items as never });
}

export const getPaymentsChart = async (startDate: string, endDate: string) => {
    return convexAction(api.node.adminExports.paymentStats, { startDate, endDate });
}

export const exportPayments = async (filters: { startDate?: string; endDate?: string }) => {
    const { url, filename } = await convexAction(api.node.adminExports.payments, filters);
    await downloadUrl(url, filename);
}
